import { Component, ElementRef, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { pluck, map } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

// Models
import { PDA } from '../../models/PDA';
import { Assistance } from 'src/app/business/models/PDA';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';
// Queries
import { PDAQuery } from '../../queries/pda.query';
// Services
import { HelpersService } from 'src/app/shared/services/helpers.services';
import { setPageTitle } from 'src/app/shared/utilities/utils';
import { MetatagsService } from 'src/app/shared/services/metatags.service';
import { CanonicalRoutesService } from 'src/app/shared/services/canonical-routes.service';

@Component({
  selector: 'app-pda',
  templateUrl: './pda.component.html',
  styleUrls: ['./pda.component.scss']
})
export class PDAComponent implements OnInit, OnDestroy {
  public pageData: PDA;
  public modalData: Assistance;

  @ViewChild('modalInfo') modal: ElementRef;
  public isOpen = false;

  // Pagination
  public startPage = 0;
  public endPage = 6;
  public perPage = 6;
  public totalElements = 12;

  // Breadcrumbs
  public pages: Breadcrumbs[];

  private appEnvironment: string;

  constructor(
    private route: ActivatedRoute,
    private pdaQuery: PDAQuery,
    private helpers: HelpersService,
    private app: AppService,
    private metaTags: MetatagsService,
    private canonical: CanonicalRoutesService
  ) {
    this.appEnvironment = this.app.configuration['GraphCMS']['environment'];

    this.route.params.subscribe(params => {
      this.pdaQuery
        .watch({
          friendlyId: params['friendlyId']
        })
        .valueChanges.pipe(
          pluck('data', 'pDAs'),
          map(r => r[0])
        )
        .subscribe((response: PDA) => {
          if (!response) { this.helpers.redirectTo404(); return; }
          this.pageData = response;

          const titleElement = document.querySelector('title');
          setPageTitle(titleElement, this.pageData.nombre);

          this.metaTags.setMetaTags(response.metaDescripciones);

          this.pages = [
            { page: 'Empresas', route: '/empresas', isActive: false },
            { page: this.pageData.nombre, isActive: true }
          ];
        });
    });
  }

  ngOnInit(): void {
    this.canonical.setCanonicalRoute();
  }

  ngOnDestroy(): void {
    this.metaTags.removeMetaTags(this.pageData.metaDescripciones);
  }

  openModal(card): void {
    this.modal.nativeElement.classList.add('open');
    this.modalData = card;
    document.body.style.overflow = 'hidden';
  }

  closeModal(): void {
    this.modal.nativeElement.classList.remove('open');
    document.body.style.overflow = 'auto';
  }

  clickModal(event): void {
    if (event.target === this.modal.nativeElement) {
      this.closeModal();
    }
  }

  onKeyDown(event): void {
    if (event.keyCode === 27 || event.key === 'Escape') {
      this.closeModal();
    }
  }

  updateModal(modalData, isOpen: boolean): void {
    this.pageData = modalData;
    this.isOpen = isOpen;
  }

  public nextPage(): void {
    this.startPage = this.startPage + this.perPage;
    this.endPage = this.endPage + this.perPage;
  }

  public prevPage(): void {
    this.startPage = this.startPage - this.perPage;
    this.endPage = this.endPage - this.perPage;
  }
}
